import { render } from "./teachild.vue?vue&type=template&id=1477225f"
import script from "./teachild.vue?vue&type=script&lang=js"
export * from "./teachild.vue?vue&type=script&lang=js"

import "./teachild.vue?vue&type=style&index=0&id=1477225f&lang=css"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__